// src/api/promptApi.js
import { getApi } from './axiosInstance';

// Fetch all prompts
export const fetchAllPrompts = async () => {
    try {
        console.log('Fetching all prompts...');
        const response = await getApi().get('/Prompt', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        });
        console.log('Prompts response:', response.data);
        return response.data;
    } catch (error) {
        console.error('Error fetching prompts:', error);
        if (error.response) {
            console.error('Error details:', {
                status: error.response.status,
                statusText: error.response.statusText,
                data: error.response.data,
                headers: error.response.headers
            });
            
            // If we get a 500 error with HTML content, it might be a proxy issue
            if (error.response.status === 500 && 
                typeof error.response.data === 'string' && 
                error.response.data.includes('<!DOCTYPE html>')) {
                throw new Error('Server returned HTML instead of JSON. This might indicate a proxy or server configuration issue.');
            }
        } else if (error.request) {
            console.error('No response received:', error.request);
        } else {
            console.error('Error setting up request:', error.message);
        }
        throw error;
    }
};

// Fetch specific prompt by ID
export const fetchPromptById = async (id) => {
    try {
        console.log('Fetching prompt with ID:', id);
        const response = await getApi().get('/Prompt/GetFullPrompt', {
            params: { id: id }
        });
        console.log('Prompt details response:', response.data);
        return response.data;
    } catch (error) {
        console.error(`Error fetching prompt with ID ${id}:`, error);
        if (error.response) {
            console.error('Error response:', {
                status: error.response.status,
                data: error.response.data,
                headers: error.response.headers
            });
        }
        throw error;
    }
};

// Create a new prompt
export const createPrompt = async (promptData) => {
    try {
        const response = await getApi().post('/Prompt', promptData);
        return response.data;
    } catch (error) {
        console.error('Error creating prompt:', error);
        throw error;
    }
};

// Delete a prompt by ID
export const deletePrompt = async (id) => {
    try {
        console.log('Attempting to delete prompt with ID:', id);
        const response = await getApi().delete('/Prompt', {
            params: { Id: id }
        });
        console.log('Delete response:', response.data);
        return response.data; // Should return true on success
    } catch (error) {
        console.error(`Error deleting prompt with ID ${id}:`, error);
        if (error.response) {
            console.error('Error response:', {
                status: error.response.status,
                data: error.response.data,
                headers: error.response.headers
            });
        }
        throw error;
    }
};